import isEmpty from 'lodash/isEmpty';

import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate, toSentenceCase } from '../../utils';
import { contactPersonRole, getFullName } from '../Person/utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach(
    ({
      buildingName,
      general,
      unit,
      unitName,
      recipient,
      createdAt,
      type,
      pickUp,
      signatureRequired,
      comments,
      creator,
      signOutData,
    }) => {
      let unitOrType = '';
      if (general) {
        unitOrType = 'General delivery';
      } else if (unit && unitName) {
        unitOrType = unitName;
      }

      let recipientOrUnit = '';
      if (general) {
        recipientOrUnit = '';
      } else if (isEmpty(recipient) && unit) {
        recipientOrUnit = 'Unit delivery';
      } else {
        recipientOrUnit = getFullName(recipient);
      }

      rows.push([
        buildingName,
        unitOrType,
        recipientOrUnit,
        contactPersonRole(recipient),
        formatDate(createdAt),
        formatDate(signOutData?.signedOutAt),
        type?.displayName,
        pickUp ? 'Yes' : 'No',
        signOutData?.id ? 'Yes' : 'No',
        signatureRequired ? 'Yes' : 'No',
        comments,
        getFullName(creator),
        contactPersonRole(creator),
        getFullName(signOutData?.signee),
        signOutData?.signOutType ? toSentenceCase(signOutData.signOutType) : '',
      ]);
    },
  );
  return { headers, rows };
};

const DeliveryListExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default DeliveryListExport;
